import React, { useEffect, useState } from "react";
import axios from "axios";
import "./PartnersSection.scss";

const API_BASE = "https://api.ainfotech.com.np";

export default function PartnersSection() {
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancel = false;

    const loadPartners = async () => {
      try {
        setLoading(true);
        const res = await axios.get(`${API_BASE}/api/partners?page=1&limit=100`);
        const list = Array.isArray(res.data?.items) ? res.data.items : [];

        if (!cancel) setPartners(list);
      } catch (err) {
        console.error("Failed to load partners", err);
      } finally {
        if (!cancel) setLoading(false);
      }
    };

    loadPartners();

    return () => {
      cancel = true;
    };
  }, []);

  if (loading) {
    return (
      <section className="avena-partners-section">
        <div className="container">
          <div className="avena-partners-section__loading">Loading partners...</div>
        </div>
      </section>
    );
  }

  if (!partners.length) return null;

  return (
    <section className="avena-partners-section">
      <div className="container">
        <div className="avena-partners-section__header">
          <div className="avena-partners-section__badge">OUR PARTNERS</div>

          <h2 className="avena-partners-section__title">
            Partnering for Long-Term  <span>Success</span>
          </h2>

          {/* <p className="avena-partners-section__subtitle">
            We proudly collaborate with organizations across IT, construction,
            hospitality and many more sectors.
          </p> */}
        </div>

        <div className="avena-partners-section__grid">
          {partners.map((partner) => (
            <div className="avena-partners-section__item" key={partner.id}>
              <div className="avena-partners-section__card">
                <img
                  src={`${API_BASE}${partner.image}`}
                  alt={partner.name}
                  loading="lazy"
                />

                <div className="avena-partners-section__overlay">
                  <span>{partner.name}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}